import PropertyTable from 'components/PropertyListTable';

function PropertyManagement() {
  return <PropertyTable />;
}

export default PropertyManagement;
